import { AuthService } from "../resource";

const AuthModule = {
  namespaced: true,
  state: {
    data: [],
    user: {
      BranchId: 0,
      BranchName: "",
      FName: "",
      Id: 0,
      IsActive: 0,
      LName: "",
      PersonId: 0,
      Type: 0,
      Username: "",
    },
    profile :[] 

  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    },
    SET_PROFILE(state, data) {
      state.profile = data;
    },
    SET_USER(state, data) {
      state.user.BranchId   = data.BranchId
      state.user.BranchName   = data.BranchName
      state.user.FName =   data.FName
      state.user.Id   = data.Id
      state.user.IsActive   = data.IsActive
      state.user.LName =   data.LName
      state.user.PersonId   = data.PersonId
      state.user.Type   = data.Type
      state.user.Username = data.Username
    },
    CLEAR_USER(state, data) {
      this.user.BranchId =  0
      this.user.FName =  ""
      this.user.Id =  0
      this.user.IsActive =  0
      this.user.LName =  ""
      this.user.PersonId =  0
      this.user.Type =  0
      this.user.Username =  ""
    }
  },
  actions: {
    ForgotPassword({ commit, state }, data) {
      return AuthService.ForgotPassword(data);
    },
    ResetPassword({ commit, state }, data) {
      return AuthService.ResetPassword(data);
    },
    setUser({ commit, state }, data) {
      commit("SET_USER", data);
    },
    createData({ commit, state }, data) {
      return AuthService.AuthCreate(data);
    },
    updateData({ commit, state }, data) {
      return AuthService.AuthUpdate(data);
    },
    deleteData({ commit, state }, data) {
      return AuthService.AuthDelete(data);
    },
    async getProfile({ commit, state }, data) {
      return AuthService.GetProfileMe();
      // try {
      //   const data = await AuthService.GetProfileMe();
      //   if (data.data.Data == null) {
      //     commit("SET_PROFILE", {});
      //   } else {
      //     commit("SET_PROFILE", data.data.Data[0]);
      //   }
      // } catch (err) {
      //   console.log(err)
      //   commit("SET_PROFILE", {});
      // }
    },
    changeProfile({ commit, state }, data) {
      return AuthService.ChangeProfileMe(data);
    },
    changePassword({ commit, state }, data) {
      return AuthService.ChangePasswordMe(data);
    },
     SignIn({ commit, state }, data) {
      return  AuthService.SignIn(data);
    },
    async listData({ commit, state }) {
      try {
        const data = await AuthService.AuthList();
        if (data.data.Data == null) {
          commit("SET_DATA", []);
        } else {
          commit("SET_DATA", data.data.Data);
        }
      } catch (err) {
        commit("SET_DATA", []);
      }
    },
    async signOut({ commit, state }) {
      try {
        const data = await AuthService.SignOut();
        commit("CLEAR_USER", state.user);
      } catch (err) {
        commit("CLEAR_USER", state.user);
      }
    }
  },
  getters: {
    getData(state) {
      return state.data;
    },
    getUser(state) {
      return state.user;
    },
    IsAuthenticate(state) {
      return state.user.Id != "";

    },
    IsAdmin(state) {
      return state.user.Type == 3;
    },
    IsUser(state) {
      return state.user.Type == 2;
    },
    IsActive(state) {
      return state.user.IsActive == 1;
    }
  }
};

export default AuthModule;
